interface ProfileArticleFooterProps {
  avatar: string
  name: string
  type: string
}

function ProfileArticleFooter({
  avatar,
  name,
  type,
}: ProfileArticleFooterProps) {
  return (
    <div className='flex px-5 justify-center items-center gap-[106px] self-stretch'>
      <div className='flex h-auto p-3 items-center gap-1 rounded-[30px] bg-[#EBFBFF]'>
        <div
          className='w-[24px] h-[24px] flex-shrink-0 bg-cover bg-center bg-no-repeat'
          style={{
            backgroundImage: `url(${avatar}), linear-gradient(to bottom, lightgray, lightgray)`,
          }}
        ></div>
        <div className='flex pr-1.5 flex-col items-start'>
          <p className='text-center text-xs font-normal leading-[12px] text-[#000]'>
            {name}
          </p>
          <p className='text-center text-xs font-normal leading-[12px] text-[#000]'>
            {type}
          </p>
        </div>
      </div>
    </div>
  )
}

export default ProfileArticleFooter
